export const APP_VERSION = '2.3.2'
